import React from "react";
import rigbyHead from "../rigby-head.png";
import QuickReplies from "./QuickReplies";
import { MOODS, STARTERS } from "./moodOpeners";

// What a new chat looks like before the student has typed anything.
export default function FirstOpen({ firstName, onMood, onStarter }) {
  return (
    <section className="rg-first" aria-label="Start a conversation">
      <img className="rg-first-mark" src={rigbyHead} alt="" />
      <h2 className="rg-first-title">Hey {firstName || "there"}.</h2>
      <p className="rg-first-sub">How are you arriving today?</p>
      <p className="rg-label">Optional</p>
      <div className="rg-moods" role="group" aria-label="Pick a mood">
        {MOODS.map((m) => (
          <button key={m.id} type="button" className="rg-mood" onClick={() => onMood(m.id)}>
            {m.label}
          </button>
        ))}
      </div>
      <QuickReplies chips={STARTERS} onPick={onStarter} center />
    </section>
  );
}
